import { render, staticRenderFns } from "./modificaUtente.vue?vue&type=template&id=2077faa3"
import script from "./modificaUtente.vue?vue&type=script&lang=js"
export * from "./modificaUtente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports